import React, { useEffect, useState, useRef } from 'react'

// next components

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// custom functions
import { useViewport } from 'utils'

// resources
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// styles
import styles from './index.module.scss'

// call apis
import dashboardAPI from 'apis/dashboard'
import TrendingBrandCard from 'components/Card/TrendingBrandCard'
import TrendingBrandCardMobile from 'components/Card/TrendingBrandCardMobile'

const TrendingBrandSection = props => {
  const {} = props
  const viewport = useViewport()
  const [trendingBrandList, settrendingBrandList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const swiperRef = useRef(null)

  const fetchTrendingBrand = async () => {
    try {
      setIsLoading(true)
      const response = await dashboardAPI.getFeedData('trending-brand')
      if (response && Array.isArray(response.cards)) {
        settrendingBrandList(response.cards)
      }
    } catch (error) {
      console.error('Error fetching shop physical data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchTrendingBrand()
  }, [])

  useEffect(() => {
    if (!isLoading && swiperRef.current && trendingBrandList.length > 0) {
      // Use setTimeout to ensure DOM is fully rendered before repositioning
      const timer = setTimeout(() => {
        if (swiperRef.current) {
          // Force swiper to update and reposition slides after data loads
          swiperRef.current.update()
          swiperRef.current.slideToLoop(0, 0, false)
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoading, trendingBrandList.length])

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full h-[32px] lg:h-[60px] g-container flex justify-between items-center">
        <div className={styles.headerContent}>
          <div className={styles.title}>Trending Brands</div>
        </div>
        <div className="lg:flex hidden items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>
      <div className={`lg:block hidden mt-[25px]`}>
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? true : false}
          slidesPerView={1.75}
          spaceBetween={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? 20 : 11}
          centeredSlides={true}
          loop={trendingBrandList.length > 1}
          modules={[Navigation]}
          className={'heroMobileNavigationSwiper'}
          initialSlide={0}
          onSwiper={swiper => {
            swiperRef.current = swiper
            // Update swiper position after initialization if data is loaded
            if (trendingBrandList.length > 0 && !isLoading) {
              setTimeout(() => {
                if (swiper) {
                  swiper.update()
                  if (swiper.slideToLoop) {
                    swiper.slideToLoop(0, 0, false)
                  }
                }
              }, 50)
            }
          }}
        >
          {trendingBrandList.map((item, index) => (
            <SwiperSlide key={index}>
              <TrendingBrandCard data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* Mobile */}
      <div className={`w-full lg:hidden flex gap-[15px] overflow-x-auto mt-[15px] px-[16px] ${styles.hideScrollbar}`}>
        {trendingBrandList.map((item, index) => (
          <div key={index} className="max-w-[259px] min-w-[259px] h-[255px] overflow-hidden">
            <TrendingBrandCardMobile data={item} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default TrendingBrandSection
